import React, {useContext} from 'react'
import { Link, useHistory } from 'react-router-dom';
import API from '../../utils/API'
import { Button, Navbar, Nav, NavDropdown} from 'react-bootstrap';
import { UserContext } from '../../UserContext';
import careImage from '../../assets/images/care_hawaii_icon.png'
// import { OrderContext } from '../../OrderContext';


export default function MainNavbar() {

    //Used for Login
    const { isLoggedIn, setLoggedIn } = useContext(UserContext);
    const { isAdmin, setIsAdmin } = useContext(UserContext);
    const history = useHistory();

    const logout = event => {
        event.preventDefault();
        API.logoutUser();
        setLoggedIn(false);
        setIsAdmin(false);
        history.push('/SignOut')
    }
    //for Menu Order

    // const { submittedOrder } = useContext(OrderContext);
    // const sumTotalCount = Object.values(submittedOrder).reduce((total, { quantity }) => total + quantity, 0)

    return (

        <div>
            <Navbar style={{minHeight: "5vh", backgroundColor: '#efefef'}}bg="#777777" variant="light" collapseOnSelect expand="lg">
                <Navbar.Brand as={Link} to="/"><img alt='paju symbol' src={careImage} style={{height:'5vh'}}/></Navbar.Brand>
                <Navbar.Toggle />
                <Navbar.Collapse>
                <Nav className="mr-auto">
                    <Nav.Link as={Link} to="/">Home</Nav.Link>
                    <Nav.Link as={Link} to="/About">Story</Nav.Link>
                    <Nav.Link as={Link} to="/Services">Services</Nav.Link>
                    <Nav.Link as={Link} to="/Staff">Staff</Nav.Link>
                    <Nav.Link as={Link} to="/Events">Events</Nav.Link>
                    <Nav.Link as={Link} to="/Location">Location</Nav.Link>
                    <Nav.Link as={Link} to="/Careers">Careers</Nav.Link>
                    <Nav.Link as={Link} to="/Employees">Employees</Nav.Link>
                    <Nav.Link as={Link} to="/PerformanceMeasures">Performance Measures</Nav.Link>



                    {isLoggedIn ? <NavDropdown bg="light" title="Tools" id="collapsible-nav-dropdown">
                    {isAdmin? <NavDropdown.Item style={{ color: "#000000" }} as={Link} to="/SubmitEvents">Submit Events</NavDropdown.Item> : ''}
                    </NavDropdown>: ""}
                  
                </Nav>
                <br/>
                {isLoggedIn ? '':<Button variant="outline-dark" as={Link} to="/Login">Login</Button>}&nbsp;
                {isLoggedIn ? '': <Button variant="outline-dark" as={Link} to="/Registration">Register</Button>}
                {isLoggedIn ? <Button variant="outline-dark" onClick={logout}>Logout</Button>: ''}
                </Navbar.Collapse>
            </Navbar>
            
        </div>
    )
}
